import { TableComponentStyles } from 'src/app/interfaces/tables.interfaces';

export const tableComponentStyles: TableComponentStyles = {
  members: {
    index: [0, 1],
    width: [70, 10],
  },
  manage: {
    index: [0, 1, 2],
    width: [20, 50, 15],
  },
  tableWithoutManageAction: {
    index: [0, 1],
    width: [14, 55],
  },
  tableWithDateAndManage: {
    index: [0, 1, 2],
    width: [105, 30, 20],
  },
  rolesVerification: {
    index: [0, 1],
    width: [40, 170],
  },
  projectsVerification: {
    index: [0, 1],
    width: [40, 170],
  },
};
